import React from 'react';
import { EditableInfoComponent, Row } from 'components/index';
import { ContactPersonIcon } from 'components/common/icons';
import { ContactPersonAddEdit } from 'components/common/contactPerson/addEdit';
import { DeleteModal } from 'components/common/contactPerson/delete';
import { useContactPerson } from 'components/common/contactPerson/useContactPerson';
import { ContactPersonCard, ContactPersonData } from 'components/common/contactPerson/contactPersonCard';

interface IContactPerson {
  entityName: string;
  hasAccessToWrite: boolean;
  hasAccessToDelete: boolean;
}

export const ContactPerson = (props: IContactPerson) => {
  const { entityName, hasAccessToDelete, hasAccessToWrite } = props;
  const {
    addModalState,
    isDeleteOpen,
    personDetails,
    data,
    onAddModalOpen,
    onAddModalClose,
    onDeleteModalClose,
    onDeleteModalOpen,
    onUpdateModalOpen,
  } = useContactPerson();
  return (
    <>
      <EditableInfoComponent
        onAdd={onAddModalOpen}
        creatable={hasAccessToWrite}
        editable={false}
        icon={<ContactPersonIcon />}
        title={'Contact Person'}
      >
        <Row gutter={[0, 12]}>
          {data.map((contactPerson: ContactPersonData) => (
            <ContactPersonCard
              hasAccessToDelete={hasAccessToDelete}
              hasAccessToWrite={hasAccessToWrite}
              key={contactPerson.id}
              data={contactPerson}
              onDeleteModalOpen={onDeleteModalOpen}
              onUpdateModalOpen={onUpdateModalOpen}
            />
          ))}
        </Row>
      </EditableInfoComponent>
      <ContactPersonAddEdit
        entityName={entityName}
        modalState={addModalState}
        dataToEdit={personDetails}
        onModalStateChange={onAddModalClose}
      />
      <DeleteModal
        openModal={isDeleteOpen}
        onDeleteModalClose={onDeleteModalClose}
        dataToDelete={{ id: personDetails?.id }}
      />
    </>
  );
};
